import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { collection, deleteDoc, doc, getFirestore, query, Timestamp, updateDoc, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import { AppFirebase } from "../../../../config/firebase";
import ConversorHours from "../../../../components/conversorHours";
import { Swiper, SwiperSlide } from "swiper/react";
import './style.css';

export default function Watching( { movies, user } ) {
    
    const image_path = 'https://image.tmdb.org/t/p/w500';
    const [moviesLength, setMoviesLength] = useState(0);
    const [qualidadeImg, setQualidadeImg] = useState(localStorage.getItem('qualidadeImg'));
    const [removerMovieContinuarAssistindo, setRemoverMovieContinuarAssistindo] = useState(false);
    const [movie, setMovie] = useState({});
    const modalMovieAssistindo = useRef();
    const navigate = useNavigate();

    async function removerContinuarAssistindo(imdbId) {
        const profile = JSON.parse(localStorage.getItem('profile'));
        await deleteDoc(doc(getFirestore(AppFirebase), `profiles/${profile.profile_uid}/playlists/watching/movies/${imdbId}`));
    }

    async function ocultarContinuarAssistindo(imdbId) {
        const profile = JSON.parse(localStorage.getItem('profile'));
        await updateDoc(doc(getFirestore(AppFirebase), `profiles/${profile.profile_uid}/playlists/watching/movies/${imdbId}`), {
            display: false
        });
    }

    const openModalRemoveMovie = (movie) => {
        setRemoverMovieContinuarAssistindo(movie?.id);
        setMovie(movie);
    };

    const redirectMovieRemove = (redirectTo, movieType)=> {

        if (redirectTo == 'watch') {
            if (movieType == 'tv') {
                navigate(`/watch/${movie?.media_type}/${movie?.idMovie}/${removerMovieContinuarAssistindo}/${movie?.season}/${movie?.episode}`);
            } else {
                navigate(`/watch/${movie?.media_type}/${movie?.idMovie}/${removerMovieContinuarAssistindo}`);
            }
        } else if (redirectTo == 'details') {
            navigate(`/preview/${movie?.media_type}/${movie?.idMovie}`);
        }

        setTimeout(() => {
            setRemoverMovieContinuarAssistindo();
        }, 2000);
    }

    return(
        <>
            {movies?.length >= 1 &&
                <div className="content-movies-watching">

                    <div>
                        <h2 className="section-title">Continuar Assistindo</h2>
                    </div>
                    <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={0}
                    freeMode={false}
                    pagination={{
                    clickable: true,
                    }} className="div-watching">
                        {movies.map((movie, key) => {
                            return (
                                <SwiperSlide key={key} id={`movie-watching-${movie?.id}`}>
                                    <div className="movie-watching">
                                        <div onClick={()=>openModalRemoveMovie(movie)}>
                                            <img loading="lazy" src={`https://image.tmdb.org/t/p/w${qualidadeImg == 'low' ? '154' : qualidadeImg == 'medium' ? '200' : '400'}${movie?.backdrop_path}`} alt={movie?.title} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src="https://dflix.netlify.app/imagens/img-erro-exclamacao.png"; currentTarget.height='50px'}}/>
                                            <section className="section-info-watching">
                                                <section>
                                                    {movie?.media_type == 'tv' &&
                                                        <div className="div-porcentos-assistidos">
                                                            <div style={{width: `${(( movie?.episode_seconds_watched / movie?.episode_duration) * 100)}%`}}></div>
                                                        </div>
                                                    }
                                                </section>
                                            </section>
                                        </div>
                                        <span className="movie-watching-name">{movie?.name}</span>
                                        <div className="div-options-movie-continuar-assistindo-desktop" ref={modalMovieAssistindo}>
                                            <Link to={`/details/${movie?.media_type}/${movie?.movie_id_tmdb}/${movie?.movie_id_imdb}`} className="movie-watching-link-preview">
                                                <section>
                                                    {movie?.media_type == 'tv' &&
                                                        <span className="movie-watching-season"> T{movie?.season_number}:E{movie?.episode_number}</span>
                                                    } 
                                                    <span className="movie-watching-name movie-watching-name-details">{movie?.name}</span>
                                                </section>
                                                <section><i className="fas fa-chevron-down"></i></section>
                                            </Link>                         
                                            <section>
                                                <button className="button-watch-desktop" onClick={()=>navigate(`/details/${movie?.media_type}/${movie?.movie_id_tmdb}/${movie?.movie_id_imdb}`)}><i className="fa-solid fa-play"></i> Assistir</button>
                                                <button className="button-desktop" onClick={()=>ocultarContinuarAssistindo(movie?.id)}><i className="fa-solid fa-eye-slash"></i></button>
                                                <button className="button-desktop" onClick={()=>removerContinuarAssistindo(movie?.id)}><i className="fa-solid fa-trash-can"></i> </button>
                                            </section>                         
                                        </div>
                                    </div>
                                </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>

                    <div className={removerMovieContinuarAssistindo ? 'container-modal-remove-movie-active' : 'container-modal-remove-movie'}>
                        <div className={removerMovieContinuarAssistindo ? "div-remover-movie-continuar-assistindo-mobile-active" : "div-remover-movie-continuar-assistindo-mobile"} ref={modalMovieAssistindo}>
                            {movie &&
                                <div className="div-movie-remove-info">
                                    <header className="header-modal-remove-movie">
                                        <span className="media-type-movie">{movie?.media_type == 'tv' ? 'Série / tv' : 'Filme'}</span>
                                        <h4 className="name-movie">{movie?.name}</h4>
                                        {movie?.media_type == 'tv' ?
                                            <span className="season-episode-movie"> Temporada {movie?.season_number} | Episódio {movie?.episode_number}</span>
                                        : 
                                            <span className="season-episode-movie"> <i className="far fa-clock"> </i> {<ConversorHours minutes={movie?.runtime}/>}</span>
                                        }
                                    </header>
                                    <section>
                                        <button className="botao-playlist botao-add-playlist" onClick={()=>setRemoverMovieContinuarAssistindo()}><i className="fa-solid fa-xmark"></i> </button>
                                    </section>
                                </div>
                            }
                            <button className="bt-remover" onClick={()=>navigate(`/details/${movie?.media_type}/${movie?.movie_id_tmdb}/${movie?.movie_id_imdb}`)}><i className="fa-solid fa-play"></i> Continuar Assistindo</button>
                            <button className="bt-remover" onClick={()=>navigate(`/details/${movie?.media_type}/${movie?.movie_id_tmdb}/${movie?.movie_id_imdb}`)}><i className="fa-solid fa-info-circle"></i>Detalhes</button>
                            <button onClick={()=>ocultarContinuarAssistindo(removerMovieContinuarAssistindo)}><i className="fa-solid fa-eye-slash"></i>Ocultar</button>
                            <button className="bt-remover" onClick={()=>removerContinuarAssistindo(removerMovieContinuarAssistindo)}><i className="fa-solid fa-trash-can"></i>Remover</button>
                        </div>
                    </div>
                    
                </div>
            }
        </>
    )
}